<template>
  <div class="content">
    <!-- 上白板step -->
    <div class="nav-border">
      <span class="nav-lspan">客户名称：<span style="color: green;">{{ this.$route.query.name }}</span></span>
      <!-- 按钮 -->
      <div class="nav_but">
        <a-button class="bottom-button" type="primary" ghost @click="cancle" >返回</a-button>
      </div>
    </div>

    <!-- body -->
    <div class="body">
      <div class="body-content public_scrill">
        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid.field"
          :data-source="relevanceBatch_grid.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
          :pagination="false"
          :loading="tableLoading"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{index + 1}}
          </span>
          <!-- 反馈类型 -->
          <span slot="backType" slot-scope="text, record">
            {{ text | DictionaryFilter('FEED_TYPE') }}
          </span>
        </a-table>

        <!-- 表头 -->
        <div class="content_one" style="margin-top: 30px;">
          <div class="form_title">商品信息</div>
        </div>

        <!-- 图片 -->
        <div style="display: flex;flex-wrap: wrap;">
          <div v-for="(item, index) in imgList" :key="index" >
            <div style="border: 1px solid #e4e4e4;height: 120px;width: 120px;display: flex;justify-content: center;align-items: center; margin-left: -1px;margin-bottom: -1px;">
              <img :src="url + item" alt="" @click="handleImg(item)" style="cursor: pointer;max-width: 100%; max-height: 100%;padding: 5px; "/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 表单 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancelImg"
      class="imgBox"
    >
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
    
<script>
import {
  detailFeedBack,
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  components: {
  },
  props: {
    Title: {
      type: String,
      default: () => "Title",
    },
  },
  data() {
    return {
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 12,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "反馈类型",
            align: "center",
            width: 30,
            dataIndex: "backType",
            ellipsis: true,
            scopedSlots: {
              customRender: "backType",
            },
          },
          {
            title: "联系方式",
            colSpan: 1,
            align: "center",
            width: 30,
            ellipsis: true,
            dataIndex: "phoneNo",
          },
          {
            title: "反馈信息",
            colSpan: 1,
            width: 180,
            dataIndex: "backInfo",
            align: "center",
            ellipsis: true,
          },
        ]
      },

      //响应数据
      resDate: {},
      tableLoading: false,

      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,

      //图片集合
      imgList: [],
      //图片
      url: process.env.VUE_APP_PROXY + "base/file/download-file?id=",
      previewVisible: false,
      previewImage: "",

    };
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["FEED_TYPE"]).then((res) => {
      //查询
      this.queryList();
  }); 
  this.relevanceBatch_grid.width = 0;
  this.relevanceBatch_grid.field.map(item => {
    this.relevanceBatch_grid.width += item.width;
  });
  },
  methods: {
    /* 表格图片查看 */
    handleImg(file) {
      this.previewVisible = true;
      this.previewImage = this.url + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },
    //查询接口
    queryList() {
      detailFeedBack({ id: this.$route.query.id }).then(res => {
          this.relevanceBatch_grid.row = [];
          this.imgList = [];
          if (res.content != null && res.content != '' && res.content != undefined) {
            this.relevanceBatch_grid.row.push(res.content);
            this.imgList = res.content.attIds;
          } 
          this.tableLoading = false;
        }, (err) => {
          this.tableLoading = false;
        });
    },
    // 取消按钮
    cancle() {
      this.$router.go(-1);
    },
  },
};
</script>
    
<style lang="less" scoped>
.content {
  height: 90%;

  .nav-border {
    width: 100%;
    height: 60px;
    background: #fff;
    z-index: 100;
    display: flex;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 2px;
    .nav-lspan {
      margin-left: 100px;
      font-size: 16px;
      float: left;
      margin: 8px 8px 8px 30px;
      color: black;
      flex: 1;
    }
    .nav_but{
      margin-right: 30px;
    }
  }
  .body {
    display: flex;
    justify-content: space-between;
    height: 88%;
    background: #fff;
    .body-content {
      padding: 15px 15px 15px 15px;
      flex: 1;
      height: 100%;
      overflow-y: auto;

      .content_one{
        height: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .blank-border {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    .bottom-button {
      float: right;
      margin-left: 20px;
    }
  }
}

.addbutton {
  border: 1px #009de5 solid;
  color: #009de5;
  float: right;
  margin: 10px;
  z-index: 100;
}

/deep/ .ant-upload-list {
  display: none;
}

.uploadfilelist {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  zoom: 1;

  .fileico {
    margin: 10px;
  }
  .itemname {
  }
  .itemsta {
    float: right;
    margin-right: 30%;
  }
  .download {
    float: right;
    margin: 5px;
  }
  .del {
    float: right;
    margin: 5px;
  }
}
.uploadfilelist:hover {
  background: #f3fbff;
}

/deep/ .form_title{
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #333;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
}

.table_bottom{
  
  .bottom_btn{
    margin-top: 10px;

    .btn_first{
      margin-right: 10px;
    }
  }
}
/deep/ .ant-pagination{
  padding-top: 20px;
  text-align: right;
}
</style>